"use client";

import { cn } from "@/utils/cn";

interface BathroomsSectionProps {
	value: number | null;
	onChange: (value: number | null) => void;
	minAllowed?: number;
}

const BATHROOM_OPTIONS = [
	{ value: 1, label: "1+" },
	{ value: 2, label: "2+" },
	{ value: 3, label: "3+" },
	{ value: 4, label: "4+" },
	{ value: 5, label: "5+" },
	{ value: 6, label: "6+" },
	{ value: 7, label: "7+" },
	{ value: 8, label: "8+" },
];

export function BathroomsSection({ value, onChange, minAllowed = 0 }: BathroomsSectionProps) {
	return (
		<div className="flex border border-gray-300 rounded-xl overflow-hidden md:overflow-x-visible overflow-x-auto">
			{BATHROOM_OPTIONS.map((option, index) => {
				const isSelected = value === option.value;
				const isDisabled = option.value < minAllowed;
				return (
					<button
						type="button"
						key={option.value}
						onClick={() => {
							onChange(isSelected ? null : option.value);
						}}
						disabled={isDisabled}
						className={cn(
							"py-3 text-sm font-medium transition-colors",
							"flex-shrink-0 min-w-[60px] md:flex-1 md:min-w-0",
							index === 0 && "rounded-l-xl",
							index === BATHROOM_OPTIONS.length - 1 && "rounded-r-xl",
							index > 0 && "border-l border-gray-300",
							"px-4 py-3 text-body shadow-sm hover:bg-neutral-300 cursor-pointer",
							isDisabled ? "opacity-50 cursor-not-allowed bg-gray-100" : "cursor-pointer",
							isSelected ? "bg-primary-400 text-primary-600" : "bg-white text-gray-600 hover:bg-gray-50",
						)}
					>
						{option.label}
					</button>
				);
			})}
		</div>
	);
}
